import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { CdekLocation } from './CdekLocation'
/**
* Class UpdateOrderDeliveryCdek
*  Доставка CDEK: нужен ПВЗ.
*/
export class UpdateOrderDeliveryCdek extends ActiveModel {

  /**
  * kind
  *   */
  @ActiveField({ readonly: true, value: () => 'Cdek' })
  readonly kind: string = 'Cdek'


  /**
  * deliveryMethodId
  * Идентификатор способа из каталога канала.  */
  @ActiveField(0)
  deliveryMethodId: number = 0


  /**
  * deliverTo
  * Адрес / ПВЗ назначения CDEK.  */
  @ActiveField({
    factory: [CdekLocation, () => undefined]
  })
  deliverTo?: CdekLocation
}
